import { render, staticRenderFns } from "./no-educator.vue?vue&type=template&id=ce9581ac&scoped=true&"
import script from "./no-educator.vue?vue&type=script&lang=js&"
export * from "./no-educator.vue?vue&type=script&lang=js&"
import style0 from "./no-educator.vue?vue&type=style&index=0&id=ce9581ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9581ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
